import { render } from "./AppSearch.vue?vue&type=template&id=754b3446&scoped=true"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"

import "./AppSearch.vue?vue&type=style&index=0&id=754b3446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754b3446"]])

export default __exports__